import { FACETAS, type Faceta, type RecuentoFacetado } from '../../common/services/tipos.js';

export { FACETAS };
export type { Faceta, RecuentoFacetado };

/**
 * Cuánta cobertura necesita una columna para que su filtro se ofrezca.
 *
 * La mitad, y el porqué es el de la comprobación 8 del goal: **no se enseña un filtro vacío**. Un
 * desplegable de países con cuatro opciones sobre 144 estudios no ayuda a filtrar, engaña: quien lo
 * usa se queda con cuatro fuentes y cree que son todas las que hay de ese país.
 *
 * Medido el 2026-09-22 en el corpus: `pais` tiene dato en 4 de 144 fuentes y `tipo_poblacion` en 5.
 * Los dos se quedan fuera hoy, y volverán solos el día que la ingesta los rellene. Esta función no
 * sabe nada de eso: mira los datos que hay.
 */
export const COBERTURA_MINIMA = 0.5;

/**
 * Cuántas fuentes tienen dato en esa faceta. Se suman los recuentos, que es exactamente lo que el
 * API devuelve; las que no tienen dato simplemente no aparecen en ninguna fila.
 */
export function coberturaDe(recuentos: readonly RecuentoFacetado[], totalDeFuentes: number): number {
  if (totalDeFuentes <= 0) return 0;
  const con = recuentos.reduce((total, r) => total + r.cuantas, 0);
  return Math.min(1, con / totalDeFuentes);
}

export function seOfreceElFiltro(recuentos: readonly RecuentoFacetado[], totalDeFuentes: number): boolean {
  if (recuentos.length < 2) return false;
  return coberturaDe(recuentos, totalDeFuentes) >= COBERTURA_MINIMA;
}

/** Qué filtros se pintan, de los cuatro posibles. */
export function filtrosQueSeOfrecen(recuentos: Readonly<Record<Faceta, readonly RecuentoFacetado[]>>, totalDeFuentes: number): readonly Faceta[] {
  return FACETAS.filter(f => seOfreceElFiltro(recuentos[f], totalDeFuentes));
}
